import { DynamicFlatNode } from './DynamicFlatNode.class';
import { TreeEntityType } from './enum';
import type { MeasurementConfigurationModel } from './MeasurementConfigurationModel';

export interface IOrgaElementModel {
  children: Child[];
  elementType: ElementType;
  identifier: string;
  name: string;
  description: string;
  parentIdentifier: string;
  url: string;
}
/**
 *
 */
export class OrgaElementModel {
  /**
   *
   */
  children: OrgaElementModel[] = [];
  /**
   *
   */
  channelGroups: MeasurementConfigurationModel[] = [];
  /**
   *
   */
  elementType!: ElementType;
  /**
   *
   */
  identifier!: string;
  /**
   *
   */
  name!: string;
  /**
   *
   */
  description!: string;
  /**
   *
   */
  parentIdentifier!: string;
  /**
   *
   */
  businessUnitIdentifier!: string;
  /**
   *
   */
  url!: string;
  /**
   *
   * @param data
   */
  constructor(data?: Partial<IOrgaElementModel>) {
    if (data) {
      Object.assign(this, data);
    }
  }
  get level() {
    switch (this.elementType.type) {
      case TreeEntityType.USE_CASE_ROOT:
        return 1;
      case TreeEntityType.MASTER:
        return 2;
      case TreeEntityType.INSTANCE:
        return 3;
      case TreeEntityType.CHANNEL_GROUP:
        return 4;
      case TreeEntityType.CHANNEL:
        return 5;
      default:
        return 1;
    }
  }
  /**
   *
   * @param level
   * @returns
   */
  toDynamicFlatNode() {
    return new DynamicFlatNode({
      label: this.name,
      id: this.identifier,
      level: this.level,
      expandable: true,
      isLoading: false,
      type: this.elementType.type,
      entity: this,
    });
  }
}

interface Child {
  identifier: string;
  name: string;
}

interface ElementType {
  identifier: string;
  description: string;
  type: string;
}
